import styled, { css } from 'styled-components';

export const InputSpacing = styled.div`
  margin-bottom: ${p => p.theme.spacing(12)};
`;

export const InputFieldWrapper = styled.div`
  border: 1px solid ${p => p.theme.color.gray};
  border-radius: 5px;
  position: relative;
  width: 100%;

  @media (${p => p.theme.mq.desktop}) {
    width: 80%;
  }

  ${p =>
    p.valid &&
    css`
      &::after {
        content: '';
        background: url(${p.svg});
        height: 30px;
        right: 12px;
        top: 7px;
        position: absolute;
        width: 20px;
        background-size: cover;

        path {
          stroke: ${p.theme.color.green};
        }
      }
    `} ${p =>
    p.error &&
    css`
      border: 1px solid ${p.theme.color.red};
      box-shadow: 0 0 3px ${p.theme.color.red};
    `};
`;

export const InputFieldTitle = styled.p`
  font-weight: bold;
  margin: 0;
`;

export const InputFieldDescription = styled.p`
  margin: -4px 0 10px 0;
  font-size: 14px;
`;

export const SCInputField = styled.input`
  border: 0;
  position: relative;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: ${p => p.theme.spacing(3)};
  width: 95%;
  height: 100%;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;

  &:required {
    box-shadow: none;
  }
`;

export const ErrorMessage = styled.p`
  margin: 0;
  color: ${p => p.theme.color.red};
`;



// WEBPACK FOOTER //
// ./src/components/InputField/styles.js